<template>
  <div>
    <SettingGroup title="有効・無効">
      <SettingItem label="Bluetooth">
        <ToggleSwitch
            v-model="form.toggle.bluetoothFunction"
            :disable="false"
        />
      </SettingItem>
    </SettingGroup>

    <!-- 削除ダイアログなどがあればここに -->
  </div>
</template>

<script>
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'BluetoothOptionalFeaturesVue2',
  components: { SettingGroup, SettingItem, ToggleSwitch },

  data () {
    // ★ Vue2 ではテンプレートから直接モジュール定数を参照できないので data に載せる
    //    -> テンプレで BC_TRANS_JP... が使える
    return {
      // ← テンプレで参照するため公開
      BC,
      BC_TRANS_JP,

      // フォーム
      form: {
        toggle: {
          bluetoothFunction: false,
        },
      },

      // ストア設定
      setting: null,
    }
  },

  computed: {
    ...mapStores(useRadioSettingsStore),
  },

  created () {
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォーム
    this.transSetting2Form()

    // フォーム監視：設定へ反映 & 保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },

  methods: {
    // ===== sync: form -> setting =====
    transForm2Setting () {
      const data = this.setting && this.setting.OptionalFeatures && this.setting.OptionalFeatures.Bluetooth
      if (!data) return

      data.PresetActivation.BluetoothFunction =
          this.form.toggle.bluetoothFunction ? this.BC.COMMON.TOGGLE.ENABLE : this.BC.COMMON.TOGGLE.DISABLE
    },

    // ===== sync: setting -> form =====
    transSetting2Form () {
      const data = this.setting && this.setting.OptionalFeatures && this.setting.OptionalFeatures.Bluetooth
      if (!data) return

      this.form.toggle.bluetoothFunction =
          data.PresetActivation.BluetoothFunction === this.BC.COMMON.TOGGLE.ENABLE
    },
  },
}
</script>
